import { AwardsService } from '../services';
import { MEMBERSHIP_STATUS_LABELS } from '../statuses';
import { awardsKeys } from '../queryKeys';
import { useOptimisticStatusMutation } from './useOptimisticStatusMutation';
import { useRowStatusEditor } from './useRowStatusEditor';

/**
 * The Promotion-tab counterpart of useUpdateMembershipStatus: one user, edits
 * across many cycles, so it is keyed by userId and takes the cycleId per call.
 *
 * Unlike the roster, a not-entered row stays listed here (the history shows
 * every cycle), so the patch is always in place. A status edit is a formal
 * entry/removal, so on settle it also invalidates that cycle's roster — the
 * Cycle page's user list must gain or lose this user accordingly
 * (GOTU-4819/GOTU-5817).
 */
export const useUpdateUserCycleStatus = (userId, options = {}) => {
  const mutation = useOptimisticStatusMutation(
    {
      mutationFn: ({ cycleId, status }) =>
        AwardsService.updateMembershipStatus(cycleId, userId, status),
      snapshotKey: awardsKeys.userCyclesPrefix(userId),
      patchPage: (data, { cycleId, status }) => ({
        ...data,
        items: data.items.map((row) =>
          row.cycleId === cycleId
            ? {
              ...row,
              status,
              statusLabel: MEMBERSHIP_STATUS_LABELS[status] ?? status,
            }
            : row,
        ),
      }),
      invalidateKeys: ({ cycleId }) => [
        awardsKeys.userCyclesPrefix(userId),
        awardsKeys.membershipsPrefix(cycleId),
      ],
    },
    options,
  );

  return { ...mutation, ...useRowStatusEditor(mutation, 'cycleId') };
};
